import { render, staticRenderFns } from "./PenwiseDailyFeedData.vue?vue&type=template&id=49c3b39b&scoped=true"
import script from "./PenwiseDailyFeedData.vue?vue&type=script&lang=js"
export * from "./PenwiseDailyFeedData.vue?vue&type=script&lang=js"
import style0 from "./PenwiseDailyFeedData.vue?vue&type=style&index=0&id=49c3b39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c3b39b",
  null
  
)

export default component.exports